import React from "react";
import CompanyTreeRow from "./companyRow";
import TreeProvider from "./context";
import { useTreeContext } from "./context";
import Octicon from "react-octicon";
import { GlobalToggleButton } from "../components/GlobalToggleButton";

function SearchBar() {
  const { searchTerm, setSearchTerm } = useTreeContext();

  return (
    <div className="row mb-1">
      <div className="col-12">
        <div className="input-group">
          <div className="input-group-prepend">
            <span className="input-group-text">
              <Octicon name="search" />
            </span>
          </div>
          <input
            type="text"
            className="form-control"
            placeholder="Search companies, projects, and work packages..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
          />
          {searchTerm && (
            <div className="input-group-append">
              <button className="btn btn-outline-secondary" type="button" onClick={() => setSearchTerm("")}>
                <Octicon name="x" />
              </button>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default function CompanyTree({
  fromHere,
  ExtraContentComponent,
  tableStyles,
  TableHeaderComponent,
  excludeLevels,
  showGlobalToggle = true,
}) {
  return (
    <div className="container-fluid mt-2 m-0 p-0">
      <TreeProvider {...{ fromHere, ExtraContentComponent, excludeLevels }}>
        <SearchBar />
        {showGlobalToggle && (
          <div className="mb-2">
            <GlobalToggleButton />
          </div>
        )}
        <table
          className="table table-borderless m-0 p-0 w-100 account-tree-table"
          style={{ tableLayout: "fixed", width: "100%", ...tableStyles }}
        >
          {TableHeaderComponent && <TableHeaderComponent />}
          <tbody>
            <CompanyTreeRow />
          </tbody>
        </table>
      </TreeProvider>
    </div>
  );
}
